import { Navigate, Outlet } from "react-router-dom";
import { useSessao } from "@/hooks/use-sessao";
import { Sidebar } from "./sidebar";
import { Topbar } from "./topbar";

export function Shell() {
  const { carregando, autenticado, ehAdmin, user } = useSessao();

  if (carregando) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        Carregando...
      </div>
    );
  }

  if (!autenticado || !ehAdmin || !user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex min-h-screen bg-background text-foreground">
      <Sidebar />
      <main className="flex flex-1 flex-col overflow-x-hidden">
        <Topbar user={user} />
        <div className="mx-auto w-full max-w-6xl px-6 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
